module.exports = __webpack_public_path__ + "packs/media/images/bg_2-ecda58cd919141aaf623d7f047668712.jpg";